import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Subtitle = function Subtitle(_ref) {
  var label = _ref.label,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_jsx("p", {
    className: clsx('tw-font-label1 tw-uppercase tw-mb-2 dark:tw-text-neutral-dark-500 tw-text-neutral-light-700', className),
    children: label
  });
};
export default Subtitle;